module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 235
// module chunks = 0 1 2 3 4 6 8 9